import {useEffect, useRef} from 'react';

import {isLocal} from '@zzng/common/utils/common';

import {getScrollRestoration, setScrollRestoration} from '@/shared/utils/sessionStorage';

export const useScrollRestoration = () => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!container.current) return;
    // 전용웹뷰가 아닌 경우 스크롤 복원 기능을 사용하지 않습니다.
    // .webview 클래스 css속성(overflow:hidden;)과 관련이 있습니다.
    if (!window.digitalCard && !isLocal) return;

    const scrollTop = getScrollRestoration();

    if (scrollTop) {
      container.current.scrollTo(0, scrollTop);
    }

    let tick = false;
    const handleScroll = () => {
      if (!tick) {
        window.requestAnimationFrame(() => {
          const scrollTop = container.current?.scrollTop || 0;
          setScrollRestoration(scrollTop);
          tick = false;
        });
        tick = true;
      }
    };

    container.current.addEventListener('scroll', handleScroll, {passive: true});

    return () => {
      container.current?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {container};
};
